"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

export default function ScrollToTop() {
  const pathname = usePathname();

  useEffect(() => {
    // Only scroll to top if there's no hash in the URL
    if (!window.location.hash) {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  // Handle hash-based scrolling for anchor links (e.g., /#faq, /#features)
  useEffect(() => {
    const scrollToHash = () => {
      const hash = window.location.hash;
      if (!hash) return;

      // Try to find the element, with retries for dynamic content
      let attempts = 0;
      const maxAttempts = 5;

      const tryScroll = () => {
        const el = document.querySelector(hash);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        } else if (attempts < maxAttempts) {
          attempts++;
          setTimeout(tryScroll, 150);
        }
      };

      // Initial delay to let the DOM settle after navigation
      setTimeout(tryScroll, 100);
    };

    // Run on mount / pathname change in case of cross-page navigation with hash
    scrollToHash();

    // Listen for hash changes (same-page anchor link clicks)
    window.addEventListener("hashchange", scrollToHash);
    return () => window.removeEventListener("hashchange", scrollToHash);
  }, [pathname]);

  return null;
}
